export const baseURLEnum = Object.freeze({
  IMAGE_ACCESS:"IMAGE_ACCESS",
  USER_STORE:"USER_STORE",
  REPORT_ACCESS:"REPORT_ACCESS",
  VISOR_API:"VISOR_API",
  COLUMBIA:"COLUMBIA",
  COLUMBIA_INFO:"COLUMBIA_INFO",
  BASELINE_JWT_SERVICE:"BASELINE_JWT_SERVICE"
});
